import styled from "styled-components";

const backimg = "../../../assets/images/blog3.png";

export const Wrapper = styled.div`
  width: 100%;
  background: ${(props) => (props.themes ? "#04031D" : "#f9f9f9")};
  color: ${(props) => (props.themes ? "#f9f9f9" : "#04031D")};
`;
export const Headers = styled.div`
  min-height: 300px;
  background: url(${backimg});
  background-repeat: no-repeat;
  background-size: cover;
  padding-left: 40%;
`;